import axios, {AxiosError} from "axios";
import {uiBus} from "@/plugins/uiBus";

interface ErrorResponse {
  error?: string
}

function httpErrorHandler(error: AxiosError<ErrorResponse>) {
  if (error.response && error.response.status === 401) {
    if (error.response.data.error && error.response.data.error.match(/^Token/)) {
      uiBus.emit('login.KO');
    }
  }
  throw error;
}

axios.interceptors.response.use(
  response => response,
  httpErrorHandler
);
